// Ajusta a posição do WhatsApp inferior caso o contador inferior também esteja habilitado
function handleWhatsLatPos() {
  const $countdownFixed = $('.countdown-wrapper.fixed.bottom');
  const $whatsLateralBottom = $('.contatos-lateral.bottom-right, .contatos-lateral.bottom-left');
  if ($countdownFixed.length > 0 && $whatsLateralBottom.length > 0) {
    if (isMedia('xs') || isMedia('sm')) {
      const countdownHeight = $countdownFixed.outerHeight() + 10;
      $whatsLateralBottom.css('margin-bottom', countdownHeight);
    }
  } else {
    $whatsLateralBottom.css('margin-bottom', 0);
  }
}
handleWhatsLatPos();

// Collapse colunas
(function () {
  'use strict';

  $('.footer-collapse .footer-tit').on('click', function () {
    if (isMedia('sm') || isMedia('xs')) {
      const $tit = $(this);
      const $col = $tit.parent();
      const $content = $col.find('.footer-col-content');
      if (!$col.hasClass('active')) {
        $col.addClass('active');
        $content.slideDown();
      } else {
        $col.removeClass('active');
        $content.slideUp();
      }
    }
  });
})();

// ------------------------------------
// Voltar ao topo
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $goTop = $('.go-top');
  const $window = $(window);

  // Exibe ou oculta o botão ao rolar a página
  toggleGoTop();
  $(window).on(
    'scroll',
    debounce(function () {
      toggleGoTop();
    }, 100),
  );

  // Evento de click no botão
  $goTop.on('click', function () {
    smoothScroll('html');
  });

  // Exibe ou oculta o botão
  function toggleGoTop() {
    const scrollTop = $window.scrollTop();
    if (scrollTop > 500) {
      $goTop.addClass('active');
    } else {
      $goTop.removeClass('active');
    }
  }
})();
